var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVillageProblems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,411.1c2.6-14.8,11-26.9,18.3-39.5c60.6-105,121.3-210,181.8-315.1c11.8-20.4,29-31.3,52.8-30.3c19,0.8,34.2,9.5,44,25.8 c14.7,24.3,28.7,49.1,42.9,73.8c49.8,86.3,99.7,172.5,149.3,259c4.7,8.2,7.3,17.5,10.9,26.4c0,4.6,0,9.1,0,13.7 c-0.2,0.4-0.5,0.9-0.6,1.3c-8,32.8-27.1,47.8-60.9,47.8c-126,0-251.9,0-377.9,0c-2.3,0-4.6,0-6.8-0.1c-23.5-0.8-43.9-16.2-51-38.7 c-1.1-3.4-1.9-6.9-2.8-10.3C0,420.2,0,415.7,0,411.1z M250,453.2c64,0,127.9,0.1,191.9-0.1c5.9,0,12.2-1,17.5-3.4 c18.9-8.4,25.5-31.1,14.9-49.6c-21.6-37.7-43.4-75.2-65.1-112.8c-42.5-73.6-84.9-147.3-127.7-220.8c-3.3-5.7-8.3-11.2-13.8-14.6 c-17.3-10.9-38.2-4.4-49.1,14.4c-39.3,68-78.5,136-117.8,204C76,313,51.4,355.8,26.6,398.6c-5.3,9.2-7.4,18.6-4.5,29 c4.5,15.9,17.9,25.6,35.5,25.6C121.7,453.2,185.9,453.2,250,453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.1,240.7c0,17.7,0.2,35.5-0.1,53.2c-0.3,18-14,33.1-31.3,35.1c-18,2.1-34.4-8.6-39.2-25.8c-0.9-3.2-1.5-6.7-1.5-10.1 c-0.1-35-0.2-69.9,0-104.9c0.1-18.3,13.5-33.5,31.1-35.8c18-2.3,34.8,8.6,39.5,26c1,3.7,1.4,7.7,1.4,11.6 C286.2,206.9,286.1,223.8,286.1,240.7C286.1,240.7,286.1,240.7,286.1,240.7z M234.6,240.7c0,16.6-0.1,33.2,0.1,49.8 c0,2.9,0.3,5.9,1.3,8.6c2.4,6.5,9.2,10.3,16,9.4c7.1-0.9,12.6-6.6,13.3-14.1c0.4-4.4,0.2-8.8,0.2-13.2c0-30.2,0-60.5,0-90.7 c0-5.1-1-9.8-4.9-13.3c-4.7-4.3-10.3-5.7-16.2-3.2c-6.5,2.7-9.6,8-9.7,15C234.6,206.2,234.6,223.5,234.6,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,344.7c19.8,0,36.1,16.3,36,36.1c0,19.8-16.3,36.1-36.1,36.1c-19.8,0-36.1-16.4-36-36.1 C214,360.9,230.2,344.7,250,344.7z M265.3,380.6c-0.1-8.2-7.2-15.2-15.3-15.2c-8.2,0-15.3,7-15.3,15.2c-0.1,8.4,7.2,15.6,15.6,15.4 C258.5,395.9,265.4,388.8,265.3,380.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVillageProblems);
export default __webpack_public_path__ + "static/media/VillageProblems.f7b122d5b16409e4594e587fe739a196.svg";
export { ForwardRef as ReactComponent };